export const manufacturersCode = {
    2480: "BMP",
    1537: "APA",
    5317: "EFE",
    19950: "SON",
    20584: "TCH",
    17555: "QDS",
    16562: "PER",
    9669: "INE",
    11309: "KAM"
};
  